import { render, staticRenderFns } from "./UiGlobalReportOption.vue?vue&type=template&id=74f8babc&scoped=true&"
import script from "./UiGlobalReportOption.vue?vue&type=script&lang=js&"
export * from "./UiGlobalReportOption.vue?vue&type=script&lang=js&"
import style0 from "./UiGlobalReportOption.vue?vue&type=style&index=0&id=74f8babc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f8babc",
  null
  
)

export default component.exports